const NutrientLoading = () => {
  const NutrientLoadingData = [
    {
      Source: 'Inflows',
      'Phosphorus Mass (pounds)': '',
      'Nitrogen Mass (pounds)': '',
      _isSubHeading: true,
    },
    {
      Source: 'Cherry Creek (CC-10)',
      'Phosphorus Mass (pounds)': Number(7544).toLocaleString(),
      'Nitrogen Mass (pounds)': Number(51841).toLocaleString(),
    },
    {
      Source: 'Cottonwood Creek (CT-2)',
      'Phosphorus Mass (pounds)': Number(679).toLocaleString(),
      'Nitrogen Mass (pounds)': Number(19410).toLocaleString(),
    },
    {
      Source: 'Precipitation',
      'Phosphorus Mass (pounds)': Number(266).toLocaleString(),
      'Nitrogen Mass (pounds)': Number(5888).toLocaleString(),
    },
    {
      Source: 'Alluvial Groundwater',
      'Phosphorus Mass (pounds)': Number(1418).toLocaleString(),
      'Nitrogen Mass (pounds)': Number(3428).toLocaleString(),
    },
    {
      Source: 'Total Inflows',
      'Phosphorus Mass (pounds)': Number(9907).toLocaleString(),
      'Nitrogen Mass (pounds)': Number(80567).toLocaleString(),
      _isTotal: true,
    },
    {
      Source: 'Outflows',
      'Phosphorus Mass (pounds)': '',
      'Nitrogen Mass (pounds)': '',
      _isSubHeading: true,
    },
    {
      Source: 'Evaporation',
      'Phosphorus Mass (pounds)': Number(0).toLocaleString(),
      'Nitrogen Mass (pounds)': Number(0).toLocaleString(),
    },
    {
      Source: 'Reservoir releases',
      'Phosphorus Mass (pounds)': Number(-5210).toLocaleString(),
      'Nitrogen Mass (pounds)': Number(-47953).toLocaleString(),
    },
    {
      Source: 'Total Outflows',
      'Phosphorus Mass (pounds)': Number(-5210).toLocaleString(),
      'Nitrogen Mass (pounds)': Number(-47953).toLocaleString(),
      _isTotal: true,
    },
    {
      Source: 'WY 2021 Change in Storage',
      'Phosphorus Mass (pounds)': Number(4697).toLocaleString(),
      'Nitrogen Mass (pounds)': Number(32614).toLocaleString(),
      _isSubHeading: true,
    },
  ];

  // Declare and configure request overview table
  const NutrientLoadingTable = new requestTable({
    container: '#nutrient-loading-table',
    filterEnabled: false,
    tableHeaders: {
      Source: 'Source',
      'Phosphorus Mass (pounds)': 'Phosphorus Mass (pounds)',
      'Nitrogen Mass (pounds)': 'Nitrogen Mass (pounds)',
    },
    tableActions: [],
    tableData: NutrientLoadingData,
  });
  NutrientLoadingTable.buildTable();
};

// Build pie chart
const NutrientBalance = () => {
  const InflowProportions = new Pie({
    container: '#inflow-pie-chart',
    widthScale: 1,
    heightScale: 1,
    innerRadius: 80,
    color: d3.scaleOrdinal(['rgb(2, 117, 216)', 'rgb(255,140,0)', 'rgb(92, 184, 92)', 'rgb(128,128,128)']),
    resultField: 'rvalue',
    categoryField: 'source',
    data: [
      { source: 'Cherry Creek', rvalue: 66 },
      { source: 'Cottonwood Creek', rvalue: 18 },
      { source: 'Alluvial Groundwater', rvalue: 11 },
      { source: 'Precipitation', rvalue: 5 },
    ],
  }).draw();
};
